import { AUTH_TAB } from '../components/Auth/constants';
import { BrowserType, PlatformType } from '../constants/common';
export const capitalize = (str = '') => {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};
export const formatUsername = (str = '', charCount) => {
    const capitalizeStr = capitalize(str);
    const strLen = str.length;
    if (strLen > charCount) {
        return `${capitalizeStr.substring(0, 20)}...`;
    }
    else {
        return capitalizeStr;
    }
};
export function isObject(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}
export const delay = retryCount => new Promise(resolve => setTimeout(resolve, 10 ** retryCount));
export const toSnakeCase = (v) => {
    return v.replaceAll(' ', '_').replaceAll('-', '_').toLowerCase();
};
export const translate = (str, query = null, options) => {
    let updatedString = options.default;
    if (isObject(query) && options.default) {
        Object.keys(query).forEach(key => {
            updatedString = options.default.replace(new RegExp('{{\\s?' + key + '\\s?}}'), query[key]);
        });
    }
    return updatedString;
};
export const shuffleArray = (unshuffled) => {
    return unshuffled
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
};
export const getAuthModalParamsForToggleFavourite = () => {
    return {
        authModalVisible: true,
        onClose: () => { },
        onLoginSuccess: () => { },
        onSignUpSuccess: () => { },
        onForgotPasswordSuccess: () => { },
        initialTab: AUTH_TAB.SIGN_UP,
    };
};
export const debounceWrapper = (fn, delay = 250) => {
    let lastTimeout;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(lastTimeout);
        lastTimeout = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
};
export const getPosterURL = (poster, browser) => {
    if (!poster) {
        return;
    }
    return browser !== BrowserType.Safari && poster.webpURL
        ? poster.webpURL
        : poster.defaultURL;
};
export const getWebpURL = (url, platform = PlatformType.Desktop) => {
    const webpURL = url.slice(0, url.lastIndexOf('.')) + '.webp';
    const imageSizeText = platform === PlatformType.Desktop
        ? '/large/'
        : platform === PlatformType.Tablet
            ? '/medium/'
            : '/small/';
    return webpURL.replace('/origin/', imageSizeText);
};
export const getPngURL = (url, platform = PlatformType.Desktop) => {
    const webpURL = url.slice(0, url.lastIndexOf('.')) + '.png';
    const imageSizeText = platform === PlatformType.Desktop
        ? '/large/'
        : platform === PlatformType.Tablet
            ? '/medium/'
            : '/small/';
    return webpURL.replace('/origin/', imageSizeText);
};
export const getAppropriateUrl = (url, browser, platform = PlatformType.Desktop) => {
    url = url
        .replace('/large/', '/origin/')
        .replace('/medium/', '/origin/')
        .replace('/small/', '/origin/');
    if (url.trim().length === 0)
        return '';
    if (browser === BrowserType.Safari) {
        return getPngURL(url, platform);
    }
    return getWebpURL(url, platform);
};
